<div
	class="gap-1 w-full h-full flex scrollbar-fade overflow-auto flex-col items-start justify-start"
>
	@if ($showContent()) {
		<div #contentWrapper class="top-0 flex-none w-full sticky z-1">
			<ng-content></ng-content>
		</div>
	}
	<!-- <div class="w-full flex-auto overflow-auto flex flex-col items-start justify-start gap-1"> -->
	<!--  -->
	@for (source of $sources(); track source.id) {
		<div
			#sourceCard
			[attr.data-id]="source.id"
			class="p-2 flex rounded-1.5 gap-1 w-full bg-280 items-start justify-start"
			[style.scrollMarginTop]="$scrollMargin()"
		>
			<div
				class="rounded-circle flex-none text-xs w-2 h-2 fc-white flex items-center justify-center bg-line-330"
			>
				{{ source.inlineNumber }}
			</div>

			<div class="flex-auto">
				{{ source.content }}
			</div>
		</div>
	}
	<!-- </div> -->
</div>
